// Real pages from KUNSTKLAR Bind 1 (WebP in Impultienda Recursos).
export const pageSamples: Array<{
  src: string;
  label: string;
  title: string;
  text: string;
}> = [{
  src: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/c9415f6a-f635-4dea-a6bf-9bdc54b57875/1792558226174_kk-bind1-side01-33291e5f.webp',
  label: 'Bind 1 · Forside',
  title: 'Årsplan & 12 ferdige økter',
  text: 'For 1.–4., 5.–7. og 8.–10. trinn, koblet til LK20 – med fargelære og form som rød tråd.'
}, {
  src: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/c9415f6a-f635-4dea-a6bf-9bdc54b57875/1792558230347_kk-bind1-side05-4a3d448f.webp',
  label: 'Årsplan · Side 5',
  title: 'Årsplan 1.–4. trinn',
  text: 'Måned for måned med tema og aktivitet – så du alltid vet hva neste time skal handle om.'
}, {
  src: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/c9415f6a-f635-4dea-a6bf-9bdc54b57875/1792558234239_kk-bind1-side12-87f0ec82.webp',
  label: 'Økt 1 · Side 12',
  title: 'Primærfargene',
  text: 'En ferdig økt for 1.–2. trinn: mål, materialer, minutt for minutt og lærerinstruksjon.'
}, {
  src: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/c9415f6a-f635-4dea-a6bf-9bdc54b57875/1792558237864_kk-bind1-side24-02a35c69.webp',
  label: 'Økt 7 · Side 24',
  title: 'Edvard Munch: Farger som følelser',
  text: 'Bildesamtale i 4 steg og et selvportrett med følelser i bakgrunnen – for 6.–7. trinn.'
}, {
  src: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/c9415f6a-f635-4dea-a6bf-9bdc54b57875/1792558241713_kk-bind1-side26-4e3318d6.webp',
  label: 'Økt 8 · Side 26',
  title: 'Perspektiv med ett forsvinningspunkt',
  text: 'Steg for steg med skisser, minutt for minutt og lærerinstruksjon – klar til 90 minutter.'
}];
